module.exports = __webpack_public_path__ + "static/media/1.3be9f700.jpg";